import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class ClientServiceWorkerMixin extends Vue {
    private workerMessageHandler: ((e: MessageEvent) => void) | null = null;

    mounted() {
        const workerPort = (this as any).$workerPort as MessagePort | undefined;
        if (!window.SharedWorker || !workerPort) return;

        this.workerMessageHandler = (e: MessageEvent) => this.onClientServiceWorkerMessage(e);
        workerPort.addEventListener('message', this.workerMessageHandler);
        this.onClientServiceWorkerReady(workerPort);
    }

    beforeDestroy() {
        const workerPort = (this as any).$workerPort as MessagePort | undefined;
        if (this.workerMessageHandler && workerPort) {
            workerPort.removeEventListener('message', this.workerMessageHandler);
            this.workerMessageHandler = null;
        }
    }

    protected sendToWorker(type: string, data?: any): void {
        const workerPort = (this as any).$workerPort as MessagePort | undefined;
        if (workerPort) {
            workerPort.postMessage([type, data ?? null]);
        }
    }

    protected onClientServiceWorkerMessage(_e: MessageEvent): void {}
    protected onClientServiceWorkerReady(_port: MessagePort): void {}
}
